import { AppProps } from 'next/app'
import Head from 'next/head'
import styles from './styles.module.scss'
import globalStyles from '@bt-react/styles'

const assetsPath = process.env.NODE_ENV === 'production' ? '/presenting' : ''

function CustomApp({ Component, pageProps }: AppProps) {

  return (
    <>
      <Head>
        <title>Presenter Access | BrightTALK</title>
        <meta name='robots' content='noindex,nofollow'></meta>
        <link rel='icon' type='image/png' href={`${assetsPath}/images/favicon.ico`} />
      </Head>
      <div className={`${globalStyles['bootstrap-container']}`}>
        <main className={styles['app']}>
          <Component {...pageProps} />
        </main>
      </div>
    </>
  );
}

export default CustomApp;
